//首页
const home = () => import('@/views/home');


const routes = [
    {
	    path: '/',
	    name: "home",
	    component: home,
	    meta: {
	        title: '高等学历继续教育（网络教育）'
	    }
	}
]
export default routes;